/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertClientSearchResult } from './ControlZeroDayAlertClientSearchResult';
import {
    ControlZeroDayAlertClientSearchResultFromJSON,
    ControlZeroDayAlertClientSearchResultFromJSONTyped,
    ControlZeroDayAlertClientSearchResultToJSON,
} from './ControlZeroDayAlertClientSearchResult';

/**
 * 
 * @export
 * @interface ControlGetZeroDayAlertClientsResponse
 */
export interface ControlGetZeroDayAlertClientsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertClientsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertClientsResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlGetZeroDayAlertClientsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlZeroDayAlertClientSearchResult>}
     * @memberof ControlGetZeroDayAlertClientsResponse
     */
    results: Array<ControlZeroDayAlertClientSearchResult>;
}

/**
 * Check if a given object implements the ControlGetZeroDayAlertClientsResponse interface.
 */
export function instanceOfControlGetZeroDayAlertClientsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlGetZeroDayAlertClientsResponseFromJSON(json: any): ControlGetZeroDayAlertClientsResponse {
    return ControlGetZeroDayAlertClientsResponseFromJSONTyped(json, false);
}

export function ControlGetZeroDayAlertClientsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetZeroDayAlertClientsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlZeroDayAlertClientSearchResultFromJSON)),
    };
}

export function ControlGetZeroDayAlertClientsResponseToJSON(value?: ControlGetZeroDayAlertClientsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlZeroDayAlertClientSearchResultToJSON)),
    };
}

